import { Box, Stack } from '@mui/material';

import { NewConvergeNotes } from '../../../newNotes';
import { NoteTargetAreaType } from '@converge/graphql';

interface IBrokerNoteContainerProps {
  brokerUuid: string | undefined;
}

export const BrokerNoteContainer = ({
  brokerUuid,
}: IBrokerNoteContainerProps) => {
  return (
    //Todo targetname targetuuid and targetType needs to be update
    <>
      <Stack>
        <Stack>
          <Box>
            <NewConvergeNotes
              title="Broker Notes"
              targetUuid={brokerUuid}
              targetArea={NoteTargetAreaType.Person}
              hideHeader={false}
              containerWidth={12}
              testId="broker-notes-section"
              inputTestId="broker-notes-input"
              buttonTestId="save-note-button"
            />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};
